import { InfoOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const DetailsContent = () => {
  return (
    <Box
      sx={{
        p: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "gray",
        fontWeight: "bold",
      }}
    >
      <Box>
        <Typography>Contract Address</Typography>
        <Typography>Token ID</Typography>
        <Typography>Token Standard</Typography>
        <Typography>Chain</Typography>
        <Typography>Last Updated</Typography>
        <Typography sx={{ display: "flex", alignItems: "center" }}>
          Creator Earning <InfoOutlined fontSize='inherit' sx={{ ml: 1 }} />
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "right",
          justifyContent: "right",
          textAlign: "right",
        }}
      >
        <Typography color='#2282e2' fontWeight={"bold"}>
          0x5af0...25a5
        </Typography>
        <Typography color='#2282e2' fontWeight={"bold"}>
          1780
        </Typography>
        <Typography>ERC-721</Typography>
        <Typography>Ethereum</Typography>
        <Typography>5 months ago</Typography>
        <Typography>5%</Typography>
      </Box>
    </Box>
  );
};

export default DetailsContent;
